export enum QueryKeys {
  GetSource = "sources",
  GetSourceProjects = "source#projects",
  GetProject = "projects",
  GetProjectEnrollees = "project#enrollees",
  GetProjectRenewals = "project#renewals",
  GetEnrollees = "enrollees",
  GetCertificates = "certificates",
  GetEnrolleeCertificates = "enrollee#certificates",
}
